import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

interface Props {
  onUpdate?: () => void;
}

const NotifyOnUpdatePlugin = ({ onUpdate }: Props) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (onUpdate == null) {
      return;
    }

    return editor.registerUpdateListener(() => {
      onUpdate?.();
    });
  }, [editor, onUpdate]);

  return null;
};

export { NotifyOnUpdatePlugin };
